import WorkFromHome from "features/WorkFromHome";

export const DRAWER_MENU_LABEL = {
  DASHBOARD: "DASHBOARD",
  Employees: "Employees",
  Attendance: "Attendance",
  Payroll: "Payroll",
  Jobs: "Jobs",
  Candidates: "Candidates",
  Leaves: "Leaves",
  Holidays: "Holidays",
  Settings: "Settings",
  LeaveManagement: "Leave Management",
  TransportManagement: "Transport Managament",
  ScheduleManagement: "Schedule Managament",
  EmployeeEngagement: "Employee Engagement",
  InventoryManagement: "Inventory Management",
  Tickets: "Tickets",
  MasterData: "Master Data",
  UserPermissions: "User Permissions",
  AccessManagement: "Access Management",
  ProjectManagement: "Project Management",
  ProjectUserManagement: "Project Management",
  TaskManagement: "Task Management",
  GoalManagement: "Goal Management",
  NoticeBoard: "Notice Board",
  UserTracking: "User Tracking",
  Invites: "Invites",
  GapAnalysis: "Gap Analysis",
  CrowdsourcePayment: "Crowdsource Payment",
  Crowdsource: "Crowd Source",
  WorkFromHome: "Work from Home",
  AcxioRooms: "Acxio Hubs",
  Profiling: "Profiling",
};
